import { Pipe, PipeTransform } from '@angular/core';

import { AnyValues } from '../interfaces/undetermined';

@Pipe({ name: 'keys', pure: false })
export class KeysPipe implements PipeTransform {

  /* transform(): Pipe que devuelve las propiedades de un objeto
    value: Cualquier objeto con o sin propiedades
  */
  transform = (value: AnyValues): string[] => typeof value === 'object' ? Object.keys(value) : [];

}
